// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
The UX design for this ImageExportCards is using a lot of customization.
In the UI, we replicate the group component "ServiceCard" which is the closest to the design, and override some defaults.
*/

.fctl-imageexport-card .pf-v6-c-content--h2 {
  --pf-v6-c-content--h2--FontWeight: normal;
}

.fctl-imageexport-card .fctl-imageexport-card__status .pf-v6-c-button {
  /* Status is placed in the card title and needs a smaller font */
  --pf-v6-c-button--FontSize: 0.75rem;
}
`, "",{"version":3,"sources":["webpack://./../../libs/ui-components/src/components/ImageBuilds/ImageExportCards.css"],"names":[],"mappings":"AAAA;;;CAGC;;AAED;EACE,yCAAyC;AAC3C;;AAEA;EACE,gEAAgE;EAChE,mCAAmC;AACrC","sourcesContent":["/* \nThe UX design for this ImageExportCards is using a lot of customization.\nIn the UI, we replicate the group component \"ServiceCard\" which is the closest to the design, and override some defaults.\n*/\n\n.fctl-imageexport-card .pf-v6-c-content--h2 {\n  --pf-v6-c-content--h2--FontWeight: normal;\n}\n\n.fctl-imageexport-card .fctl-imageexport-card__status .pf-v6-c-button {\n  /* Status is placed in the card title and needs a smaller font */\n  --pf-v6-c-button--FontSize: 0.75rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
